import logger from "../utils/logger";
export const handleMarketplaceSubmit = async ({
  event,
  companyId,
  marketplaceForm,
  request,
  setBusy,
  setStatus,
  showStatus,
  setMarketplaceForm,
  initialMarketplace,
  loadMarketplaces,
  onCreated
}) => {
  event.preventDefault();
  if (!companyId) {
    showStatus('error', 'Компания не выбрана. Перезайдите снова.');
    return;
  }
  if (!marketplaceForm.account_name.trim()) {
    showStatus('error', 'Название кабинета обязательно.');
    return;
  }
  if (!marketplaceForm.api_key.trim()) {
    showStatus('error', 'API-ключ обязателен.');
    return;
  }
  if (marketplaceForm.marketplace_type === 'ozon' && !marketplaceForm.seller_id.trim()) {
    showStatus('error', 'Seller ID обязателен для OZON.');
    return;
  }
  setBusy(true);
  setStatus(null);
  try {
    const payload = {
      marketplace_type: marketplaceForm.marketplace_type,
      account_name: marketplaceForm.account_name,
      api_key: marketplaceForm.api_key,
      company_id: companyId,
      project_id: marketplaceForm.project_id || null
    };
    if (marketplaceForm.marketplace_type === 'ozon') {
      payload.seller_id = marketplaceForm.seller_id;
      if (marketplaceForm.client_id) {
        payload.client_id = marketplaceForm.client_id;
      }
      if (marketplaceForm.client_secret) {
        payload.client_secret = marketplaceForm.client_secret;
      }
    }
    const account = await request('/api/v1/marketplaces/', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    setMarketplaceForm(initialMarketplace);
    showStatus('success', 'Кабинет добавлен. Проверка прошла успешно.');
    await loadMarketplaces(companyId);
    if (onCreated) {
      await onCreated(account);
    }
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось добавить кабинет. Проверьте ключи.');
  } finally {
    setBusy(false);
  }
};
export const handleValidate = async ({
  accountId,
  request,
  setValidations
}) => {
  setValidations(prev => ({
    ...prev,
    [accountId]: {
      status: 'loading'
    }
  }));
  try {
    const result = await request(`/api/v1/marketplaces/${accountId}/validate`, {});
    setValidations(prev => ({
      ...prev,
      [accountId]: result
    }));
  } catch (error) {
    logger.error(error);
    setValidations(prev => ({
      ...prev,
      [accountId]: {
        is_valid: false,
        error: 'Ошибка проверки'
      }
    }));
  }
};
